(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-video-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apple-video-popup')) {
    customElements.define('apple-video-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.link = this.querySelector('.apple-popup-link');
        this.playButton = this.querySelector('[data-play]');
        if (!this.dialog || !this.video || !this.link) return;
        this.editor = this.dataset.editor === 'true';
        this.startedAt = performance.now();
        this.clockBase = Number(this.dataset.serverNow) * 1000;
        this.clockAt = performance.now();
        this.key = 'istyle_apple_popup_' + this.dataset.campaign.replace(/[^a-z0-9_-]/gi, '_');
        this.desktop = matchMedia('(min-width: 768px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.on(this.querySelector('[data-close]'), 'click', () => this.close());
        this.on(this.querySelector('[data-preview]'), 'click', () => this.open());
        this.on(this.dialog, 'close', () => this.restore());
        this.on(this.dialog, 'keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...this.dialog.querySelectorAll('button, a[href]')].filter(element => !element.hidden && element.getClientRects().length > 0);
          const first = items[0];
          const last = items[items.length - 1];
          if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
            event.preventDefault();
            (event.shiftKey ? last : first)?.focus();
          }
        });
        this.on(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        });
        this.on(this.playButton, 'click', () => this.play());
        this.on(this.link, 'click', () => {
          this.track('select_promotion');
          this.close();
        });
        this.on(this.video, 'error', () => {
          if (!this.video.getAttribute('src')) return;
          this.playButton.hidden = true;
          if (!this.video.poster) {
            this.video.hidden = true;
            this.querySelector('.apple-popup-fallback').hidden = false;
          }
        });
        this.on(this.desktop, 'change', () => { if (this.dialog.open) this.loadVideo(); });
        this.on(this.reducedMotion, 'change', () => {
          if (this.reducedMotion.matches && this.dialog.open) {
            this.video.pause();
            this.playButton.hidden = false;
          }
        });
        this.on(document, 'visibilitychange', () => {
          if (document.hidden && this.dialog.open) {
            this.video.pause();
            this.playButton.hidden = false;
          }
          this.tick();
        });
        this.on(window, 'pageshow', () => this.tick());
        this.on(window, 'pagehide', () => this.close());
        ['CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnDialogHide', 'CookiebotOnDialogDisplay', 'CookiebotOnConsentReady'].forEach(name => this.on(window, name, () => this.tick()));
        if (!this.editor && this.dataset.enabled === 'true') this.syncClock();
      }

      on(target, event, callback) {
        target?.addEventListener(event, callback, { signal: this.abort.signal });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.close();
        this.abort?.abort();
        this.abort = null;
      }

      async syncClock() {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 3000);
        try {
          const response = await fetch(this.dataset.root || '/', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: controller.signal });
          const serverDate = Date.parse(response.headers.get('date') || '');
          if (response.ok && Number.isFinite(serverDate)) {
            this.clockBase = serverDate;
            this.clockAt = performance.now();
          }
        } catch (_) {
        } finally {
          clearTimeout(timeout);
          if (this.isConnected) {
            this.clockReady = true;
            this.tick();
          }
        }
      }

      now() { return this.clockBase + performance.now() - this.clockAt; }

      date(value) {
        return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      }

      consentReady() {
        const bot = window.Cookiebot;
        if (!bot) return !document.getElementById('Cookiebot');
        const banner = document.getElementById('CybotCookiebotDialog');
        const visible = banner && getComputedStyle(banner).display !== 'none' && getComputedStyle(banner).visibility !== 'hidden' && banner.getClientRects().length > 0;
        return bot.hasResponse === true && !bot.dialog?.visible && !visible;
      }

      seen() {
        if (this.shown) return true;
        return document.cookie.split(';').some(item => item.trim().startsWith(this.key + '='));
      }

      tick() {
        clearTimeout(this.timer);
        if (this.editor || !this.isConnected || this.dataset.enabled !== 'true' || !this.clockReady) return;
        const start = this.date(this.dataset.start);
        const end = this.dataset.end ? this.date(this.dataset.end) : Infinity;
        if (!Number.isFinite(start) || Number.isNaN(end) || end <= start || !this.link.getAttribute('href') || !this.dataset.desktop || !this.dataset.mobile) return;
        const now = this.now();
        if (now >= end) { this.close(); return; }
        if (this.dialog.open) {
          if (!this.consentReady()) this.close();
          else if (Number.isFinite(end)) this.timer = setTimeout(() => this.tick(), Math.min(1000, end - now));
          return;
        }
        if (this.seen() || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account)(?:\/|$)/i.test(location.pathname)) return;
        if (now < start) {
          this.timer = setTimeout(() => this.tick(), Math.min(60000, start - now));
          return;
        }
        const busy = document.hidden || !this.consentReady() || document.querySelector('dialog[open], .hpstr_modal.open, .drawer.active');
        if (busy) {
          this.readyAt = null;
          this.timer = setTimeout(() => this.tick(), 1000);
          return;
        }
        if (this.readyAt == null) this.readyAt = performance.now();
        const remaining = Number(this.dataset.delay) * 1000 - (performance.now() - this.readyAt);
        if (remaining > 0) { this.timer = setTimeout(() => this.tick(), remaining); return; }
        this.open();
      }

      open() {
        if (this.dialog.open || (!this.editor && this.seen()) || !this.link.getAttribute('href')) return;
        if (typeof this.dialog.showModal !== 'function') return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        this.loadVideo();
        this.querySelector('[data-close]').focus({ preventScroll: true });
        if (!this.editor) {
          this.shown = true;
          const seconds = Math.max(1, Number(this.dataset.hours) || 24) * 3600;
          document.cookie = this.key + '=1; Max-Age=' + seconds + '; Path=/; SameSite=Lax; Secure';
          this.track('view_promotion');
          this.tick();
        }
      }

      loadVideo() {
        const mobile = !this.desktop.matches;
        this.video.pause();
        this.video.hidden = false;
        this.querySelector('.apple-popup-fallback').hidden = true;
        this.video.muted = true;
        this.video.poster = mobile ? this.dataset.mobilePoster : this.dataset.desktopPoster;
        this.video.src = mobile ? this.dataset.mobile : this.dataset.desktop;
        this.video.load();
        this.playButton.hidden = !this.reducedMotion.matches;
        if (!this.reducedMotion.matches) this.play();
      }

      play() {
        if (!this.dialog.open) return;
        if (this.video.ended) this.video.currentTime = 0;
        this.playButton.hidden = true;
        const pending = this.video.play();
        if (pending) pending.catch(() => { if (this.dialog.open) this.playButton.hidden = false; });
      }

      close() {
        this.video?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.restore();
      }

      restore() {
        this.video?.pause();
        if (!this.locked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }

      track(eventName) {
        if (this.editor || window.Cookiebot?.consent?.statistics !== true) return;
        const promotion = { creative_slot: 'apple_video_popup', promotion_id: this.dataset.campaign, promotion_name: this.dataset.promotion, creative_name: this.dataset.creative + (this.desktop.matches ? ' Desktop' : ' Mobile') };
        try {
          if (eventName === 'select_promotion') {
            sessionStorage.setItem('lastClickedPromotionId', promotion.promotion_id);
            sessionStorage.setItem('lastClickedPromotionName', promotion.promotion_name);
            sessionStorage.setItem('lastClickedCreativeName', promotion.creative_name);
            sessionStorage.setItem('lastClickedCreativeSlot', promotion.creative_slot);
          }
          window.PromotionTracking?.push(eventName, promotion);
        } catch (_) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: true } }));
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: false } }));
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: true } }));
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.dispatchEvent(new CustomEvent('headerSticky', { detail: { isSticky: false } }));
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-cart"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
